import decode from 'jwt-decode';
import { Lease } from '@common/license/types';

let leaseToken: string = null;

const getLeaseToken = () => leaseToken;

const saveLeaseToken = (token: string): Lease => {
  leaseToken = token;
  const lease: Lease = decode(token) as Lease;

  return lease;
};

const deleteLeaseToken = () => {
  leaseToken = null;
};

export { deleteLeaseToken, getLeaseToken, saveLeaseToken };
